import { render } from "./TransfertsPage.vue?vue&type=template&id=7f65fab4&ts=true"
import script from "./TransfertsPage.vue?vue&type=script&lang=ts"
export * from "./TransfertsPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__